/**
 * Pricing Calculator Constants
 *
 * All magic numbers and strings used in pricing calculations
 */

// ============================================================================
// OPTION TYPES
// ============================================================================

/**
 * Option type for dimension fields (width, height, etc.)
 */
export const DIMENSION_OPTION_TYPE = 4;

// ============================================================================
// CONVERSION FACTORS
// ============================================================================

/**
 * Conversion factor from millimeters to meters
 */
export const MM_TO_METERS = 1000;

// ============================================================================
// PRICING OPERATORS
// ============================================================================

/**
 * Check if value/option exists (no comparison)
 */
export const OPERATOR_EXISTS = 'exists';

/**
 * Greater than comparison (>)
 */
export const OPERATOR_GREATER_THAN = '>';

/**
 * Less than comparison (<)
 */
export const OPERATOR_LESS_THAN = '<';

/**
 * Greater than or equal comparison (>=)
 */
export const OPERATOR_GREATER_EQUAL = '>=';

/**
 * Less than or equal comparison (<=)
 */
export const OPERATOR_LESS_EQUAL = '<=';

/**
 * Equal comparison (==)
 */
export const OPERATOR_EQUAL = '==';

/**
 * Strict equal comparison (===)
 */
export const OPERATOR_EQUAL_STRICT = '===';

/**
 * Not equal comparison (!=)
 */
export const OPERATOR_NOT_EQUAL = '!=';

/**
 * Strict not equal comparison (!==)
 */
export const OPERATOR_NOT_EQUAL_STRICT = '!==';

/**
 * Differs operator — trigger fires when the expected option's name differs from
 * the trigger option's name (colour-name comparison, not ID comparison).
 */
export const OPERATOR_DIFFERS = 'differs';

// ============================================================================
// PRICING OPERATIONS
// ============================================================================

/**
 * Add a fixed amount to the price
 */
export const OPERATION_ADD = 'add';

/**
 * Subtract a fixed amount from the price
 */
export const OPERATION_SUBTRACT = 'subtract';

/**
 * Multiply by a value (used for per-meter pricing)
 */
export const OPERATION_MULTIPLY = 'multiply';

// ============================================================================
// RULE STATES
// ============================================================================

/**
 * Rule is active and should be evaluated
 */
export const RULE_STATE_ACTIVE = 0;

/**
 * Rule is inactive and should be ignored
 */
export const RULE_STATE_INACTIVE = 1;
